import { Container } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Page = styled(Container)`
  margin-top: 64px;
  display: flex;
  justify-content: center;
`;
